import React, { useState, useEffect } from 'react';
import Page from 'components/Templates/Page';
import Msg from 'components/Msg';
import BtnTitle from 'components/BtnTitle';
import Button from 'components/Button';
import api from 'services/api';
import { useHistory } from "react-router-dom";

import './style.css';
import FieldSelect from 'components/FieldSelect';
import InputSelectSearch from 'components/InputSelectSearch';

export default function AddCertificate() {

    const history = useHistory();

    const [userId, setUserId] = useState('');
    const [levelId, setLevelId] = useState('');

    const [users, setUsers] = useState([])
    const [levels, setLevels] = useState([])

    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState({ message: '', type: '' });


    useEffect(() => {
        const loadUsers = async () => {
            const response = await api.get(`admin/clients?limit=2000`);
            const data = response.data.map((item) => {
                return {
                    value: item._id,
                    label: item.name
                }
            })
            setUsers(data)
        }
        loadUsers();

        const loadLevels = async () => {
            const response = await api.get(`admin/ondemand/levels`);
            setLevels(response.data);
        }
        loadLevels();

    }, []);


    const addCertificate = async () => {

        setIsLoading(true);

        try {
            await api.post('/admin/ondemand/certificates', { userId, levelId });
            setIsLoading(false);
            setMsg({ message: 'Certificado adicionada com sucesso.', type: 'success' });
            setUserId('');
            setLevelId('');

        } catch (error) {
            setIsLoading(false);
            if (error.response?.data.msg) {
                const msg = error.response.data.msg;
                setMsg({ message: msg, type: 'error' });
                return;
            }
            setMsg({ message: 'Falha de conexão.', type: 'error' });
        }
    }


    return (
        <Page name="ondemand">
            <h1>
                Gerar Certificado
                <BtnTitle label="Voltar" iconName="chevron-left" handleOnClick={() => history.goBack()} />
            </h1>


            <div className="informacoes">

                <div className="container">
                    <h3>Informações</h3>
                    <InputSelectSearch id="user" options={users} handleValue={users.find((item) => item.value === userId)} handleOnChange={(item) => setUserId(item.value)} placeholder="Selecione um aluno" />
                    <FieldSelect label="Nível" handleValue={levelId} handleOnChange={(e) => setLevelId(e.target.value)}>
                        <option value="">Selecione</option>
                        {
                            levels.map((item, index) => (
                                <option key={index} value={item._id}>{item.name} - {item.points} pts</option>
                            ))
                        }
                    </FieldSelect>
                </div>

            </div>

            {msg.message ? <Msg type={msg.type} message={msg.message} /> : null}

            <div className="areaBtnPlan">
                <Button label="Gerar Certificado" isLoading={isLoading} handleOnClick={addCertificate} handleType="submit" />
            </div>

        </Page>
    )
}
